import axios from "axios";
import { toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import "react-toastify/dist/ReactToastify.css";
import { signInEnpoint } from "../utils/Utils";
const API_URL = signInEnpoint;

const login = async (values) => {
  const finalObj = {
    email: values.email,
    password: values.password,
  };
  return toast.promise(
    new Promise(async (resolve, reject) => {
      try {
        let response = await axios.post(API_URL, finalObj);
        if (response) {
          const user = jwt_decode(response.data.token);
          const token = response.data.token;
          localStorage.setItem("agrotrust_farmdb_user", JSON.stringify(user));
          localStorage.setItem("token", token);
          resolve(user);
          return user;
        }
      } catch (error) {
        reject(error);
        console.log(error);
      }
    }),
    {
      pending: "Signing In...",
      success: "Sign In Successfully 👌",
      error: "Error Signing Up 🤯",
    }
  );
};

const logout = () => {
  localStorage.removeItem("agrotrust_farmdb_user");
};

export { login, logout, API_URL };
